import React, {useState} from 'react';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Collapse, {CollapseProps} from '@material-ui/core/Collapse';
import CloseIcon from '@material-ui/icons/Close';
import Button from '../common/button/Button';
import hideAlert from './utils/hideAlert';
import AlertMessage from './AlertMessage';
import {Message} from 'epic-diesel-common';
import {AlertPopup, AlertPopupProps} from '../index';
import {AlertProps as MuiAlertProps} from '@material-ui/lab/Alert';
import {Alert as MuiAlert} from './Alert.styles';
import {AlertComponentType} from './types';

export interface AlertCta {
    message?: string;
    code?: string;
    link?: string;
    onClick?: (e?) => void;
    isExternal?: boolean;
}

export interface AlertProps extends Omit<MuiAlertProps, 'action' | 'onClose'> {
    className?: string;
    type: string;
    cta?: AlertCta;
    message: React.ReactNode;
    html?: boolean;
    closeable?: boolean;
    CollapseProps?: Omit<CollapseProps, 'in'>;
    AlertPopupProps?: boolean | Omit<Partial<AlertPopupProps>, 'type' | 'cta' | 'message'>;
    onClose?: (e, type: string) => void;
}

const Alert: React.FC<AlertProps> = ({
    className,
    children,
    type,
    cta,
    closeable,
    message,
    html,
    onClose = () => {},
    CollapseProps,
    AlertPopupProps,
    severity = 'warning',
    variant = 'standard',
    ...muiAlertProps
}) => {
    const [open, setOpen] = useState(true);

    return (
        <Collapse className={className} in={open} {...CollapseProps}>
            <MuiAlert
                {...muiAlertProps}
                variant={variant}
                severity={severity}
                action={
                    <>
                        {cta && (
                            <Button
                                fullWidth
                                color="primary"
                                onClick={cta.onClick}
                                to={cta.link}
                                isExternalUrl={cta.isExternal}>
                                {cta.message ? cta.message : <Message code={cta.code} />}
                            </Button>
                        )}
                        {closeable && (
                            <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={e => {
                                    setOpen(false);
                                    hideAlert(type, AlertComponentType.HIDE_WARNING_BAR);
                                    onClose(e, type);
                                }}>
                                <CloseIcon fontSize="inherit" />
                            </IconButton>
                        )}
                    </>
                }>
                <Typography component="div" variant="body2">
                    <AlertMessage message={message} html={html} />
                    {children}
                </Typography>

                {AlertPopupProps && (
                    <AlertPopup type={type} cta={cta} message={message} {...AlertPopupProps} />
                )}
            </MuiAlert>
        </Collapse>
    );
};

export default Alert;
